// developed by Param Partap Singh
import React from 'react'
import Nav from '../Utils/Nav'
import banner from '../Assets/background2.JPG'
import Footer from '../Utils/Footer'
import hpcmanual from '../Assets/hpc-manual.pdf'
import hostingSpaceForm from '../Assets/Hosting-space-req-form.pdf'
import { useNavigate } from "react-router-dom";
import gpuPolicies from "../Assets/GPU Uses Policy 1.0 (1).pdf";


export default function Cloud() {

    const navigate = useNavigate();
  return (
    <>
    <Nav/>
    <div className='main-container'>
        <div className="banner">
            <img className="background" src={banner} alt="" />
            <h1 className="main-heading-title">Servers</h1>
        </div>
       
        
        <div className="box-containt">
           { /*<div className="box-n">
                <h2>HPC containers</h2>
                <ul>
                    <li>High Performance Computing (HPC) facilities available at IIT Ropar. High Performance Computing (HPC) resource in IIT Ropar located in CSE Data Centers.</li>
                     <a href={hpcmanual} className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                </ul>    
            </div>*/}
            <div className="box-n">
                <h2>Compute Servers</h2>
                <ul><li>Request for Hosting Space Requirement on IT Section Server</li>
                    
                     <a href={hostingSpaceForm} className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                </ul>    
            </div>
            <div className="box-n">
                <h2>GPU Servers</h2>
                <ul>
                    <li>The NVIDIA GPU-optimized containers used for deep learning, machine learning, visualization, and high-performance computing (HPC) applications that are tested for performance, security, and scalability.</li>
                    <div className='btn-div'>
                      {/* <a href="https://sites.google.com/iitrpr.ac.in/gpuservers" className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>*/}
                    <button className='gpu-list' onClick={()=>{navigate('/gpuspecs')}}>Specifications</button>
                    <button className='gpu-list' onClick={()=>{navigate('/manuals')}}>Manuals</button>
                    <a href={gpuPolicies}  target='_blank'><button className='gpu-list' >GPU Usage Policy</button></a>
                    <button className='gpu-list' onClick={()=>{navigate('/support')}}>Support Team</button>

                    </div>
                </ul>
            </div>    
            
        </div>

    </div>

    <Footer/>
    </>
  )
}
